import { useEffect } from 'react'
import {
  TextBoxCaption1Secondary,
  TextBoxMaxLine1HeadExtra10,
} from 'atoms/TextBox/Templates'
import { useCountdown } from 'utils/hooks'
import { FIXED_INDENTS } from 'vars/index'
import { TimeBlock, TimerSC, TimerWrapper } from './Timer.styled'

export interface ITimer {
  title?: string
  daysTitle?: string
  hoursTitle?: string
  minutesTitle?: string
  secondsTitle?: string
  completionDate: string
  columnGap?: FIXED_INDENTS
  rowGap?: FIXED_INDENTS
  onTimerCompleted?: () => void
}

const MAX_DELAY_JS = Math.pow(2, 31) // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value

export const Timer = ({
  title,
  daysTitle = 'Days',
  hoursTitle = 'Hours',
  minutesTitle = 'Minutes',
  secondsTitle = 'Seconds',
  completionDate,
  rowGap = FIXED_INDENTS.INDENT_20,
  columnGap = FIXED_INDENTS.INDENT_40,
  onTimerCompleted,
}: ITimer) => {
  const { days, hours, minutes, seconds } = useCountdown(completionDate)

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined
    const millisecondsToComplete = +new Date(completionDate) - +new Date() - 100

    if (
      millisecondsToComplete > 0 &&
      completionDate &&
      millisecondsToComplete < MAX_DELAY_JS
    ) {
      timeout = setTimeout(() => onTimerCompleted?.(), millisecondsToComplete)
    }
    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [onTimerCompleted, completionDate])

  if (seconds < 0) return <></>
  return (
    <TimerWrapper rowGap={rowGap} columnGap={columnGap}>
      {title && <TextBoxCaption1Secondary title={title} />}
      <TimerSC>
        {Boolean(days) && (
          <TimeBlock>
            <TextBoxMaxLine1HeadExtra10 title={`${days}`} />
            <TextBoxCaption1Secondary title={daysTitle} />
          </TimeBlock>
        )}
        <TimeBlock>
          <TextBoxMaxLine1HeadExtra10 title={`${hours}`} />
          <TextBoxCaption1Secondary title={hoursTitle} />
        </TimeBlock>
        <TimeBlock>
          <TextBoxMaxLine1HeadExtra10 title={`${minutes}`} />
          <TextBoxCaption1Secondary title={minutesTitle} />
        </TimeBlock>
        <TimeBlock>
          <TextBoxMaxLine1HeadExtra10 title={`${seconds}`} />
          <TextBoxCaption1Secondary title={secondsTitle} />
        </TimeBlock>
      </TimerSC>
    </TimerWrapper>
  )
}
